import {
  Button,
  FormControlSizes,
  Tooltip,
  useCallbackRef,
  useSecuritiesContext,
  type OptionTypeEnum,
} from '@talos/kyoko';
import { rfqSliceActions } from '../../../../../components/OMS/NewRFQ/RFQSlice';
import { openView } from '../../../../../components/OMS/OMSSlice';
import { OMSView } from '../../../../../components/OMS/OMSView';
import { useAppStateDispatch, useAppStateSelector } from '../../../../../providers/AppStateProvider';
import type { OptionChainDataRow } from '../types';
import { isOptionPrimeable } from './OptionChainPrimeRFQButton.utils';

export const OptionChainPrimeRFQButton = ({ row, side }: { row: OptionChainDataRow; side: OptionTypeEnum }) => {
  const dispatch = useAppStateDispatch();
  const { securitiesBySymbol } = useSecuritiesContext();
  const referenceData = useAppStateSelector(state => state.referenceData);

  const symbol = row[side]?.Symbol;
  const security = symbol ? securitiesBySymbol.get(symbol) : undefined;
  const canPrime = !!security && isOptionPrimeable(referenceData, security);

  const handleClick = useCallbackRef(() => {
    if (!symbol || !canPrime) {
      return;
    }

    dispatch(openView(OMSView.RFQForm));
    dispatch(rfqSliceActions.primeNewRFQForm({ symbol }));
  });

  const tooltip = !security ? 'Market data is unavailable for this contract' : 'This contract is unavailable for RFQ';

  return (
    <Tooltip tooltip={tooltip} disabled={canPrime} tooltipTestID={`option-chain-prime-${side}-tooltip`}>
      <Button
        data-testid={`option-chain-prime-${side}-button`}
        size={FormControlSizes.Small}
        onClick={handleClick}
        disabled={!canPrime}
        width="65px"
      >
        RFQ {side}
      </Button>
    </Tooltip>
  );
};
